/* unplugin-vue-components disabled */import script from "./GeoLeaderboards.vue?vue&type=script&setup=true&lang=js"
export * from "./GeoLeaderboards.vue?vue&type=script&setup=true&lang=js"

import "./GeoLeaderboards.vue?vue&type=style&index=0&id=2b66027b&lang=scss"

const __exports__ = script;

export default __exports__